
export function set_avatar({ commit }, avatar ){

    return new Promise((resolve)=>{
        commit('SET_AVATAR',avatar);
        resolve();
    })
    
  }